import React from 'react';
import { EncompassCredentials } from './EncompassCredentials';
import { OptimalBlueCredentials } from './OptimalBlueCredentials';

export type ProfileManagementMode = 'self' | 'admin' | 'partner_delegated';

interface ProfileCredentialIntegrationsProps {
  actorUserId?: string;
  targetUserId: string;
  userEmail: string;
  firstName?: string;
  lastName?: string;
  managementMode: ProfileManagementMode;
  isAdminView?: boolean;
  presentation?: 'default' | 'profile';
}

export const ProfileCredentialIntegrations: React.FC<ProfileCredentialIntegrationsProps> = ({
  actorUserId,
  targetUserId,
  userEmail,
  firstName,
  lastName,
  managementMode,
  isAdminView = false,
  presentation = 'default'
}) => {
  const isAdminMode = managementMode === 'admin' || isAdminView;
  const isOwnProfile = Boolean(actorUserId) && actorUserId === targetUserId;
  const canViewCredentials = isAdminMode || (managementMode === 'self' && isOwnProfile);

  if (!canViewCredentials) {
    return null;
  }

  return (
    <div className={presentation === 'profile'
      ? 'lw-user-profile__credential-pair grid grid-cols-1 gap-4 md:grid-cols-2'
      : 'grid grid-cols-1 gap-6 md:grid-cols-2'}>
      <EncompassCredentials
        userId={targetUserId}
        userEmail={userEmail}
        firstName={firstName}
        lastName={lastName}
        isAdminView={isAdminMode}
        presentation={presentation}
      />

      <OptimalBlueCredentials
        userId={targetUserId}
        userEmail={userEmail}
        firstName={firstName}
        lastName={lastName}
        isAdminView={isAdminMode}
        presentation={presentation}
      />
    </div>
  );
};
